import React, { useState } from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import { pricePlanCalc } from "../../../../services/utils";
import RightModal from "../../../../components/RightModal/RightModal";
import BillingDetailsModal from "../BillingDetailsModal/BillingDetailsModal";

export default function PaymentInfo({
  plan,
  customer,
  subscription,
  updatePaymentInfos,
}) {
  const [billingDetailsToggle, setBillingDetailsToggle] = useState(false);
  if (!subscription) {
    return (
      <div className="info-card billing-info-card">
        <div className={"payment-info-head"}>
          <h2>{plan.name}</h2>
        </div>
        {customer && (
          <div className="billing-line">
            <div className={"billing-line-method"}>
              {/*<p>
            <FormattedMessage id={"billing.paymentMethod"} />
          </p>*/}
              <div> ***{customer.cardInfo.last4}</div>
              <button onClick={updatePaymentInfos}>
                <FormattedMessage id={"billing.updatePaymentInfo"} />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="info-card billing-info-card">
      {billingDetailsToggle && (
        <BillingDetailsModal
          setToggle={setBillingDetailsToggle}
          toggle={billingDetailsToggle}
          subscription={subscription}
          plan={plan}
        />
      )}
      <div className={"payment-info-head"}>
        <h2>
          <FormattedMessage id={"billing.yourKasprPlan"} />
        </h2>
        {plan.version == 2 && (
          <button onClick={setBillingDetailsToggle}>
            <FormattedMessage id={"billing.billingDetails"} />
          </button>
        )}
      </div>
      <div className="current-subscription">
        <div>
          <span>
            <FormattedMessage id={"billing.currentSubscription"} />{" "}
          </span>
          <span>
            <FormattedMessage id={"billing.subscriptionCost"} />
          </span>
        </div>
        <div>
          <div>
            <strong>
              {" "}
              {plan.numberOfMonths == 12
                ? "1 year subscription"
                : "Monthly subscription"}{" "}
            </strong>{" "}
            {subscription && (
              <span className={"date"}>
                <FormattedDate
                  value={new Date(subscription.lastRenewDate)}
                  year="numeric"
                  month="long"
                  day="numeric"
                  // weekday="long"
                />{" "}
                -{" "}
                <FormattedDate
                  value={new Date(subscription.endDate)}
                  year="numeric"
                  month="long"
                  day="numeric"
                  //  weekday="long"
                />
              </span>
            )}
          </div>
          <div>
            <strong>
              {plan.totalPrice} €{" "}
              <small style={{ fontSize: "13px", color: "#666" }}>
                {" "}
                (<FormattedMessage id={"billing.excludingTax"} /> ){" "}
              </small>{" "}
            </strong>
          </div>
        </div>
      </div>
      <div className="billing-line">
        <div>
          <p>
            <FormattedMessage id={"billing.billingCycle"} />
          </p>
          <div>
            {plan.numberOfMonths == 12 ? (
              <FormattedMessage id="billing.yearly" />
            ) : (
              <FormattedMessage id="billing.monthly" />
            )}{" "}
          </div>
        </div>
        {subscription && (
          <div>
            <p>
              <FormattedMessage id={"billing.nextBillingDate"} />
            </p>
            <div>
              <FormattedDate
                value={new Date(subscription.endDate)}
                year="numeric"
                month="long"
                day="numeric"
              />{" "}
            </div>
          </div>
        )}
        {customer && (
          <div>
            <p>
              <FormattedMessage id={"billing.paymentMethod"} />
            </p>
            <div> ***{customer.cardInfo.last4}</div>
            <button onClick={updatePaymentInfos}>
              <FormattedMessage id={"billing.updatePaymentInfo"} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
